// src/services/themeService.ts
export const applyTenantTheme = (tenantId: string) => {
    // Dynamically import tenant-specific styles
    import(`../styles/themes/${tenantId}-variables.scss`);
  };